import { render } from "./MedicalRecordSettings.vue?vue&type=template&id=08d49ff5"
import script from "./MedicalRecordSettings.vue?vue&type=script&lang=js"
export * from "./MedicalRecordSettings.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__